import React, { useState } from 'react';
import { Modal, Tooltip, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import useDeleteProjectMutation from '../hooks/mutations/useDeleteProjectMutation';
import { Project } from 'osep-generator-service-client-v1';

type Props = {
  project: Project;
};

const DeleteProject = ({ project }: Props) => {
  const { deleteProject } = useDeleteProjectMutation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      await deleteProject(project.id);
      setIsModalVisible(false);
    } catch (error) {
      console.error('Error hiding project:', error);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Tooltip title="Delete project">
        <DeleteOutlined key="delete" onClick={showModal} />
      </Tooltip>
      <Modal
        title="Confirm Delete"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        cancelText="Cancel"
      >
        <Typography.Text>
          Are you sure you want to remove this project? It will not be deleted
          from GitLab, but it will no longer be visible at the Generator.
          <br />
          <Typography.Text style={{ fontWeight: 'bold', color: 'red' }}>
            This change cannot be undone.
          </Typography.Text>
        </Typography.Text>
      </Modal>
    </>
  );
};

export default DeleteProject;
